import { render, staticRenderFns } from "./Due.vue?vue&type=template&id=4345d559&"
import script from "./Due.vue?vue&type=script&lang=js&"
export * from "./Due.vue?vue&type=script&lang=js&"
import style0 from "./Due.vue?vue&type=style&index=0&id=4345d559&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports